export default __webpack_public_path__ + "static/SFMono-Semibold-233f868a2fd7fb2b21bbb6246cebddfe.ttf";